import { InvoiceRequest, InvoiceFormData } from '../types';

const STORAGE_KEY = 'billing-requests';

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

export function createInvoiceRequest(data: InvoiceFormData): InvoiceRequest {
  const now = new Date().toISOString();
  return {
    id: generateId(),
    status: 'submitted',
    createdAt: now,
    updatedAt: now,
    data,
  };
}

export function saveInvoiceRequest(request: InvoiceRequest): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const existing = getInvoiceRequests();
      existing.push(request);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
      resolve();
    }, 500);
  });
}

export function getInvoiceRequests(): InvoiceRequest[] {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function clearAllRequests(): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      localStorage.removeItem(STORAGE_KEY);
      resolve();
    }, 300);
  });
}
